import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@bootstrap/guards/auth/auth.guard';
import { LoginGuard } from '@common/guards/login/login.guard';

const routes: Routes = [
    {
        path: 'login',
        canActivate: [LoginGuard],
        loadChildren: () => import('@auth/authentication.module').then(module => module.AuthenticationModule)
    },
    {
        path: 'logout',
        loadChildren: () => import('@auth/authentication.module').then(module => module.AuthenticationModule)
    },
    {
        path: 'ser/token',
        redirectTo: 'login/redirect'
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        loadChildren: () => import('@app/application.module').then(module => module.ApplicationModule)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class BootstrapRoutingModule {}
